export default [{
        path: '/testimonials',
        name: 'testimonials',
        component: () =>
            import ('@/views/modules/testimonials/testimonials-list/TestimonialsList.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Testimonios',
            breadcrumb: [{
                text: 'Lista de testimonios',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/testimonial/:id/edit',
        name: 'testimonials-edit',
        component: () =>
            import ('@/views/modules/testimonials/testimonials-edit/TestimonialsEdit.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Testimonios',
            breadcrumb: [{
                text: 'Lista de testimonios',
                to: { name: 'testimonials' }
            }, {
                text: 'Editar testimonio',
                active: true
            }],
            requiresAuth: true
        }
    }
]
